import React from 'react';

export const BiometricSettingsSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header section */}
      <div className="flex flex-wrap gap-y-4 justify-between items-center">
        <div>
          <div className="h-8 w-48 bg-gray-200 rounded-md animate-pulse"></div>
          <div className="h-5 w-64 bg-gray-200 rounded-md animate-pulse mt-1"></div>
        </div>
        <div className="h-10 w-40 bg-gray-200 rounded-xl animate-pulse"></div>
      </div>

      {/* Devices grid */}
      <div
        className="grid grid-cols-1 md:grid-template-columns-fit gap-6"
        style={
          {
            '--min-card-width': '400px',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(min(100%, var(--min-card-width)), 1fr))',
          } as React.CSSProperties
        }
      >
        {/* Generate 3 device skeleton cards */}
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="relative p-6 rounded-xl border border-[#E4E8EA] bg-white"
          >
            {/* Header with Name and Status */}
            <div className="flex justify-between items-start mb-6">
              <div className="min-w-0 flex-1">
                <div className="flex items-start gap-2">
                  <div className="h-7 w-40 bg-gray-200 rounded-md animate-pulse"></div>
                  <div className="h-6 w-20 bg-gray-200 rounded-full animate-pulse"></div>
                </div>
                <div className="mt-1 h-5 w-32 bg-gray-200 rounded-md animate-pulse"></div>
              </div>

              {/* Menu Button */}
              <div className="h-8 w-8 bg-gray-200 rounded-md animate-pulse"></div>
            </div>

            {/* Device Info */}
            <div className="space-y-4">
              {/* IP and Location container */}
              <div className="flex flex-wrap gap-4">
                <div className="w-[180px]">
                  <div className="h-4 w-20 bg-gray-200 rounded-md animate-pulse"></div>
                  <div className="mt-1 h-6 w-36 bg-gray-200 rounded-md animate-pulse"></div>
                </div>
                <div className="flex-1 min-w-[180px]">
                  <div className="h-4 w-20 bg-gray-200 rounded-md animate-pulse"></div>
                  <div className="mt-1 h-6 w-full bg-gray-200 rounded-md animate-pulse"></div>
                </div>
              </div>

              <div className="min-w-0">
                <div className="h-4 w-24 bg-gray-200 rounded-md animate-pulse"></div>
                <div className="mt-1 h-6 w-40 bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
